import { ForwardedRef, forwardRef } from 'react';
import { StyleLinkProps } from 'sly/hubPage/components/HubDynamicContent/SharedComponents/StyledLink/StyleLink.types';

const StyledLink = forwardRef(
  (
    { children, href }: StyleLinkProps,
    ref: ForwardedRef<HTMLAnchorElement>
  ) => {
    return (
      <a
        className='cursor-pointer border-[1px] border-[#E7E8EA] hover:shadow-[0_0.25rem_1rem_0_rgb(0_0_0_/_10%)]'
        ref={ref}
        href={href}
      >
        {children}
      </a>
    );
  }
);

export default StyledLink;
